<!-- SMT合同、协议 -->
<template>
  <div class="submit-protocol">
    <el-checkbox v-model="val" @change="handleEmit" class="submit-protocol__checkbox">
      我已阅读并同意
      <template v-if="isDevelopOrder">
        <BaseLink @click.prevent="$refs.smtProtocolDialogRef.open()">《研发型订单SMT贴片用户协议》</BaseLink>
        和
        <BaseLink @click="showDevelopPdf">《PCBA研发型订单合作框架协议》</BaseLink>
      </template>
      <template v-else>
        <BaseLink @click.prevent="$refs.smtProtocolDialogRef.open()">《华秋SMT贴片用户协议》</BaseLink>
        和
        <BaseLink @click="showPdf">
          《PCBA销售合作协议》
        </BaseLink>
      </template>
    </el-checkbox>
    <!-- SMT贴片用户协议弹框（通用版） -->
    <SmtProtocolDialog ref="smtProtocolDialogRef" :is-develop-order="isDevelopOrder" />
     <!-- PDF预览组件 -->
    <pdf-preview-dialog
      :visible.sync="pdfVisible"
      :pdf-url="currentPdfUrl"
      :file-name="currentFileName"
      :dialog-title="currentDialogTitle"
      @download-start="handleDownloadStart"
      @download-success="handleDownloadSuccess"
      @download-error="handleDownloadError"
    />
  </div>
</template>

<script>
import SmtProtocolDialog from './smtProtocolDialog'
import PdfPreviewDialog from './PdfPreviewDialog.vue'
import CONFIG from '@@/config'
import { getToken } from '@@/utils/auth'
import axios from 'axios'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    pcbaPdfName: {
      type: String,
      default: 'Xxx'
    },
    // 订单类型：0-标准型 1-研发型
    is_develop_order: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    PdfPreviewDialog,
    SmtProtocolDialog
  },
  data() {
    return {
      pdfVisible: false,
      currentPdfUrl: '',
      currentFileName: 'document.pdf',
      currentDialogTitle: '',
      val: false
    }
  },
  computed: {
    // 是否为研发型订单
    isDevelopOrder() {
      return Number(this.is_develop_order) === 1
    }
  },
  methods: {
      // PDF下载开始事件
    handleDownloadStart(url) {
      console.log('开始下载PDF:', url)
    },
    
    // PDF下载成功事件
    handleDownloadSuccess(data) {
      console.log('PDF下载成功:', data)
      this.$message.success(`文件 ${data.fileName} 下载成功！`)
    },
      // PDF下载失败事件
    handleDownloadError(error) {
      console.error('PDF下载失败:', error)
      this.$message.error(`PDF下载失败: ${error.error}`)
    },
    showPdf() {
      // 根据订单类型设置不同的PDF URL和标题
      if (this.isDevelopOrder) {
        this.currentPdfUrl = `${CONFIG.HQPCBA_HOST}/pcba/app/bom/downloadAgreement?userName=${this.pcbaPdfName || ''}`
        this.currentFileName = '《PCBA研发型订单合作框架协议》.pdf'
        this.currentDialogTitle = 'PCBA研发型订单合作框架协议'
      } else {
        this.currentPdfUrl = `${CONFIG.SMTSERVICE_HOST}/online/exportPcbaContract?party_aname=${this.pcbaPdfName || ''}`
        this.currentFileName = '《PCBA销售合作协议》.pdf'
        this.currentDialogTitle = 'PCBA销售合作协议'
      }
      this.pdfVisible = true
    },
    showDevelopPdf() {
      // 这个方法现在可以统一使用showPdf的逻辑，保留以兼容旧代码
      this.showPdf()
    },
    handleEmit() {
      this.$emit('input', this.val)
    },
    // 下载PCBA协议（使用axios获取blob后下载）
    async handleDownloadPCBAPDF() {
      try {
        // 根据订单类型使用不同的下载链接
        let url = ''
        if (this.isDevelopOrder) {
          // 研发型订单
          url = `${CONFIG.HQPCBA_HOST}/pcba/app/bom/downloadAgreement?userName=${this.pcbaPdfName || ''}`
        } else {
          // 标准型订单
          url = `${CONFIG.SMTSERVICE_HOST}/online/exportPcbaContract?party_aname=${this.pcbaPdfName || ''}`
        }
        
        // 获取token
        const token = getToken() || localStorage.getItem('token')
        
        // 使用axios获取PDF blob，可以添加Authorization header
        const response = await axios.get(url, {
          responseType: 'blob',
          headers: {
            'Authorization': token || ''
          }
        })
        
        // 创建blob并下载
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        
        // 设置文件名
        const fileName = this.isDevelopOrder 
          ? '《PCBA研发型订单合作框架协议》.pdf' 
          : '《PCBA销售合作协议》.pdf'
        link.download = fileName
        
        // 触发下载
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        // 清理blob URL
        window.URL.revokeObjectURL(blobUrl)
        
        this.$message.success('下载成功')
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('下载失败，请重试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-protocol {
  margin-top: 8px;
  .submit-protocol__checkbox ::v-deep {
    .el-checkbox__input.is-focus .el-checkbox__inner,
    .el-checkbox__inner:hover {
      border-color: $--color-primary;
    }
    .el-checkbox__input.is-checked {
      .el-checkbox__inner {
        border-color: $--color-primary;
        background-color: $--color-primary;
      }
      & + .el-checkbox__label {
        color: inherit;
      }
    }
  }
}
</style>